import React from 'react';
import PropTypes from 'prop-types';

export const QuantitySelect = function(props) {
  if (props.min > props.max) {
    return null;
  } else if (props.max === 0) {
    return null;
  }
    const options = (__range__(props.min, props.max, true).map((i) => <option value={i} key={i}>{i}</option>));

    return <div className="em-select-input">
      <select {...props}>
        <option value={0}>0</option>
        {options}
      </select>
      <i className="fas fa-sort-down"></i>
    </div>;

};

QuantitySelect.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number
};

QuantitySelect.defaultProps = {
  min: 1,
  max: 20
};

function __range__(left, right, inclusive) {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
